<template>
    <div>
        <v-toolbar class="mtb-toolbar" dark prominent>
            <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/mtb/get-ids`">
                <span
                    v-bind:class="{ 'mtb-nav-bar-btn-selected': mtbPage=='get-ids', 'mtb-nav-bar-btn-default': mtbPage != 'get-ids' }"
                 >
                    <v-btn>Patients</v-btn>
                </span>
            </router-link>
            <!--<router-link style="text-decoration: none;" :to="`${this.$store.getters.getRouterBaseURL}/mtb/mtb-preparation`">
                <span
                    v-bind:class="{ 'mtb-nav-bar-btn-selected': this.mtbPage=='mtb-preparation', 'mtb-nav-bar-btn-default': this.mtbPage != 'mtb-preparation' }"
                 >
                    <v-btn>MTB Preparation</v-btn>
                </span>
            </router-link>-->
            <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/mtb/mtb-slides`">
                <span
                    v-bind:class="{ 'mtb-nav-bar-btn-selected': mtbPage=='mtb-slides', 'mtb-nav-bar-btn-default': mtbPage != 'mtb-slides' }"
                 >
                    <v-btn>MTB Presentation</v-btn>
                </span>
            </router-link>
            <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/mtb/mtb-config`">
                <span
                    v-bind:class="{ 'mtb-nav-bar-btn-selected': mtbPage=='mtb-config', 'mtb-nav-bar-btn-default': mtbPage != 'mtb-config' }"
                 >
                    <v-btn>MTB Setup</v-btn>
                </span>
            </router-link>
            <select id="tumorboard-selector" v-model="current_mtb" disabled>
                <option v-for="i in [3,2,1]" :value="`mtb-${i}`">MTB-{{i}}</option>
            </select>
        </v-toolbar>
    </div>
</template>
<script setup lang="js">
import { ref, onMounted, computed } from 'vue';
import id_requests from "@/methods/id_requests";
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
const route = useRoute();
const store = useStore();
const current_patient = computed(() => store.state.presentation_current_patient);
const all_patients = computed(() => store.state.presentation_all_patients);

const current_mtb = computed({
    get () {
        return store.state.current_mtb;
    },
    async set (mtb) {
        store.dispatch('setCurrentMTB', mtb);
        await id_requests.getMTBData(current_mtb.value);
        await store.dispatch("setIDList", store.state.mtb_data[current_mtb.value]);
        if (current_patient.value && current_patient.value !== null && all_patients.value)
            if (!Object.keys(all_patients.value).includes(current_patient.value.id)) store.dispatch('setPresentationPatient', null);
    }
});

onMounted(async () => {
    if (route.path) {
        let route_parts = route.path.split("/")
        if (route_parts.length>1) {
            mtbPage.value = route_parts[ route_parts.length-1 ]
        } else {
            mtbPage.value = "get-ids"
        }
    }
});

const mtbPage = ref("get-ids")
</script>
<style>
.mtb-nav-bar-btn-selected {
    background-color: #c3e4ff;
    padding-left: 20px; padding-right: 20px;
    padding-top: 10px; padding-bottom: 10px;
}
.mtb-nav-bar-btn-default {
    background-color: #FFFFFF;
    padding-left: 20px; padding-right: 20px;
    padding-top: 10px; padding-bottom: 10px;
}

.mtb-toolbar {
    margin: auto;
    position: relative;
}

</style>

<style scoped>

#tumorboard-selector {
    width: fit-content;
    padding: 4px 32px;
    max-width: 150px;
    background-color: white;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2%;
    -moz-appearance: menulist;
    border: 2px solid #e3e3e3;
    border-radius: 2px;
}


</style>
